package com.swetdot.swetgram.domain

enum class DailyTaskKind { MESSAGE, DISCOVER_POST, DISCOVER_LIKE, STEPS, DISCOVER_SAVE, REPLY, PICSO_POST, PICSO_REACT, PICSO_SAVE, UNKNOWN }

enum class DailyTaskState { ACTIVE, COMPLETED, REPLACED, EXPIRED, CANCELLED, UNKNOWN }

enum class DailyTaskDestination { CHATS, DISCOVER, PICSO, STEP_PERMISSION, NONE, UNKNOWN }

data class DailyTaskItem(
    val id: String,
    val code: String,
    val kind: DailyTaskKind,
    val destination: DailyTaskDestination,
    val goal: Int,
    val progress: Int,
    val xpReward: Int,
    val state: DailyTaskState,
    val completedAt: String?,
    val version: Int,
) {
    val completed: Boolean get() = state == DailyTaskState.COMPLETED
    val progressFraction: Float get() = if (goal <= 0) 0f else (progress.toFloat() / goal).coerceIn(0f, 1f)
}

data class DailyTasks(
    val id: String,
    val localDate: String,
    val timezone: String,
    val startsAt: String,
    val expiresAt: String,
    val tasks: List<DailyTaskItem>,
    val completedCount: Int,
    val totalCount: Int,
    val earnedXp: Int,
    val bonusXp: Int,
    val replacementAvailable: Boolean,
    val completedAt: String?,
    val version: Int,
)

data class TasksProfile(
    val timezone: String,
    val totalXp: Int,
    val spendableXp: Int = 0,
    val level: Int,
    val currentStreak: Int,
    val longestStreak: Int,
    val streakFreezes: Int = 0,
    val stepTasksEnabled: Boolean,
    val notificationsEnabled: Boolean,
    val version: Int,
)
